import { Image, ImageCarousel } from '@/features/shared';
import { MuiContainer, MuiIconButton, MuiTab, MuiTabs } from '@/features/shared/material-ui';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import clsx from 'clsx';
import React, { ChangeEvent, forwardRef, memo, useState } from 'react';
import { ImageSliderWithTabsProps } from './ImageSliderWithTabs.interface';
import useStyles from './ImageSliderWithTabs.styles';

// tab start
const a11yProps = (index: any) => {
  return {
    id: `horizontal-images-tab-${index}`,
    'aria-controls': `horizontal-images-tabpanel-${index}`,
  };
};

export const CustomTabComponent = forwardRef((props: any, ref: any) => {
  const { children, title, ...tabProps } = props;
  const hasimage = title.original;

  return (
    <div {...tabProps} ref={ref}>
      {hasimage && <Image image={title} type="card" size="cover" position="center" />}
    </div>
  );
});

const ImageSliderWithTabs = ({ content, index = 0, theme, labels }: ImageSliderWithTabsProps) => {
  const classes = useStyles({});
  const [value, setValue] = useState(index);
  const images = content?.contentList || [];

  // eslint-disable-next-line @typescript-eslint/ban-types
  const handleChange = (event: ChangeEvent<any>, newValue: number) => {
    setValue(newValue);
  };

  const handleSyncNav = (currentValue: number, nextValue: number) => {
    setValue(nextValue);
  };

  if (images && images.length === 0) return null;

  const PrevButton = ({ className, ...props }: any) => {
    return (
      <MuiIconButton
        // TODO(luissardon): Replace with resource bundle
        aria-label="Preview Image"
        className={clsx(classes.navArrow, classes.prevArrow, className, 'gtm-scroll')}
        {...props}
      >
        <ChevronLeftIcon color="inherit" fontSize="large" />
      </MuiIconButton>
    );
  };

  const NextButton = ({ className, ...props }: any) => {
    return (
      <MuiIconButton
        // TODO(luissardon): Replace with resource bundle
        aria-label="Next Image"
        className={clsx(classes.navArrow, classes.prevArrow, className, 'gtm-scroll')}
        {...props}
      >
        <ChevronRightIcon color="inherit" fontSize="large" />
      </MuiIconButton>
    );
  };

  const rootClassName = clsx(classes.root, `${theme}-theme`);

  return (
    <div className={rootClassName}>
      <MuiContainer className="medium">
        <ImageCarousel
          content={content}
          index={value}
          syncNav={handleSyncNav}
          pagination
          theme={theme}
          labels={labels}
          size="contain"
        />

        <MuiTabs
          orientation="horizontal"
          variant="scrollable"
          scrollButtons="on"
          value={value}
          onChange={handleChange}
          // TODO(luissardon): Replace with resource bundle
          aria-label="Horizontal Bottom images"
          className={classes.tabs}
          ScrollButtonComponent={({ direction, ...props }: any) =>
            /left/.test(direction) ? <PrevButton {...props} /> : <NextButton {...props} />
          }
        >
          {images &&
            images
              .filter((item: any) => Boolean(item.image))
              .map((item: any, i) => (
                <MuiTab
                  // eslint-disable-next-line react/no-array-index-key
                  key={`tab_${i + 1}`}
                  title={item.image}
                  {...a11yProps(i)}
                  component={CustomTabComponent}
                  className={clsx(classes.tab, 'gtm-photo')}
                  data-imagename={item?.image?.title}
                />
              ))}
        </MuiTabs>
      </MuiContainer>
    </div>
  );
};

export default memo(ImageSliderWithTabs);
